import React, { useEffect, useState, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./Task.css";
import BigText from "../../Text/BigText/BigText.jsx";
import useApiRequests from "../../../hooks/useApiRequests.tsx";
import MoveTaskModal from "../../MoveTaskModal/MoveTaskModal.tsx";
import ExternalFactorModal from "../../ExternalFactorModal/ExternalFactorModal.tsx";
import { VendaERPDefaultStatus } from "../../../Utils/staticData.js";
import {
  Button,
  Col,
  Form,
  Row,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import {
  IFrontTask,
  IPartnerCustomerRelationship,
  ITaskAction,
} from "../../../interfaces/ITask.tsx";
import { IStatus } from "../../../interfaces/IStatus.tsx";

import { IMember } from "../../../interfaces/IMember.tsx";

import Box from "@mui/material/Box";
import { useNotification } from "../../../hooks/useNotification";
import { FaLongArrowAltRight, FaStar } from "react-icons/fa";

import {
  FaCirclePlay,
  FaCirclePause,
} from "react-icons/fa6";

import UploadDbModal from "../../UploadDbModal/UploadDbModal";
import MediaViewer from "../../MediaViewer/MediaViewer.tsx";
import axios from "axios";
import DeleteCommentModal from "../../Modal/DeleteCommentModal.tsx";
import AproveCustomizationModal from "../../Modal/AproveCustomizationModal.tsx";
import AproveTaskModal from "../../Modal/AproveTaskModal.tsx";
import EditCommentModal from "../../Modal/EditCommentModal.tsx";
import AvoidTaskModal from "../../Modal/AvoidTaskModal.tsx";
import EditDeadlineModal from "../../Modal/EditDeadlineModal.tsx";
import NewCommentModal from "../../Modal/NewCommentModal.tsx";
import ViewerCommentCodeModal from "../../Modal/ViewerCommentCodeModal.tsx";
import TaskEvidences from "./components/TaskEvidences.tsx";
import TaskGeneralInfo from "./components/TaskGeneralInfo.tsx";
import TaskPartnerInfo from "./components/TaskPartnerInfo.tsx";
import TaskProblemSummary from "./components/TaskProblemSummary.tsx";
import TaskHistory from "./components/TaskHistory.tsx";
import { normalizeTaskFromApi } from "../../../Utils/taskUtils.ts";

function TaskView() {
  const { id } = useParams();
  const {
    getDashboardBadges,
    getTaskByTrelloId,
    moveTaskToList,
    moveTaskToNextStatus,
    getMembers,
    getTaskActions,
    addNewComment,
    getCurrentUserRole,
    getTaskDevInfo,
    stopTaskDevelopment,
    startTaskDevelopment,
    leaveTheTask,
    joinTheTask,
    avoidTask,
    editComment,
    deleteComment,
    getAllStatus,
    uploadHomologacao,
    getStatusUploadHomologacao,
    aprovePartnerTask,
    aprovePartnerCustomization,
    getCurrentMember,
    getCode,
    getTaskEvidency,
    updateDeadline
  } = useApiRequests();
  const { notify } = useNotification();
  const navigate = useNavigate();

  const [emailsUploadDb, setEmailsUploadDb] = useState<IPartnerCustomerRelationship[]>([]);
  const [currentMember, setCurrentMember] = useState<IMember>();

  const [selectedMembers, setSelectedMembers] = useState<any[]>([]);
  const [selectedTools, setSelectedTools] = useState([]);
  const [modal, setModal] = useState(false);

  const [modalAvoidTask, setModalAvoidTask] = useState(false);
  const [modalEditComment, setModalEditComment] = useState(false);
  const [modalAproveTask, setModalAproveTask] = useState(false);
  const [modalAproveCustomization, setModalAproveCustomization] = useState(false);
  const [modalDeleteComment, setModalDeleteComment] = useState(false);
  const [newPriority, setNewPriority] = useState("-1");
  const [activitiesFilter, setActivitiesFilter] = useState("-1");
  const [activities, setActivities] = useState<ITaskAction[]>([]);

  const [nextStateName, setNextStateName] = useState("");
  const [reproveStateName, setReproveStateName] = useState("");
  const [partnerCustomer, setPartnerCustomer] = useState<IPartnerCustomerRelationship[]>([]);

  const [comments, setComments] = useState<ITaskAction[]>([]);
  const [newComment, setNewComment] = useState("");
  const [commentToEdit, setCommentToEdit] = useState("");
  const [commentToDelete, setCommentToDelete] = useState("");
  const [customizationConditions, setCustomizationConditions] = useState("");
  const [userRole, setUserRole] = useState("");
  const [task, setTask] = useState<IFrontTask>({
    title: "",
    category: "",
    ticket: "",
    partnerEmail: "",
    customerEmail: "",
    partnersEmailsList: [],
    customersEmailsList: [],
    description: "",
    priority: "",
    testersIds: [],
    testersNames: [],
    complexity: "",
    finishDate: "0001-01-01T00:00:00.000Z",
    version: "",
    labelIds: [],
    partnersCustomers: [],
    emailsToNotify: [],
    resources: [],
    membersName: [],
    parentTaskId: '',
    memberIds: [],
    toolsIds: [],
    toolsName: [],
    evidencies: [],
    versions: [],
    listId: "",
    listName: "",
    testerId: "",
    testerName: "",
    screenerId: "",
    screenerName: "",
    flow: "",
    fromApi: false,
    isAproved: false,
    isCustomization: false,
    creatorName: '',
    devName: [],
    prManager: {},
    trelloId: '',
    allResourcesEvidencies: [],
    privateDescription: ""
  });

  const [taskHistory, setTaskHistory] = useState(null);
  const [isUserAssigned, setIsUserAssigned] = useState(null);
  const [modalExternalFactor, setModalExternalFactor] = useState(false)

  const [statusList, setStatusList] = useState<IStatus[]>([]);
  const [userCanScreening, setUserCanScreening] = useState(false);

  const [modalUploadDb, setModalUploadDb] = useState(false);
  const [modalMoveTask, setModalMoveTask] = useState(false);
  const [modalMoveTaskNextStatus, setModalMoveTaskNextStatus] = useState(false);

  const [statusNameToMoveManually, setStatusNameToMoveManually] = useState("");

  const [isFullscreen, setIsFullscreen] = useState(false);
  const [evidenciesIds, setEvidenciesIds] = useState<string[]>([]);
  const [evidenciesImages, setEvidenciesImages] = useState<string[]>([]);
  const [fullScreenIndex, setFullScreenIndex] = useState(0);
  const [files, setFiles] = useState<FileList | null>(null);

  //Email do viewer
  const [viewerEmail, setViewerEmail] = useState("");
  const [viewerCode, setViewerCode] = useState("");
  const [viewerCommentModal, setViewerCommentModal] = useState(false);
  const [modalEditDeadline, setModalEditDeadline] = useState(false);
  const [newDeadline, setNewDeadline] = useState("");
  const [deadlineJustification, setDeadlineJustification] = useState("");

  useEffect(() => {
    if (statusNameToMoveManually !== "") {
      setModalMoveTask(!modalMoveTask);
    }
  }, [statusNameToMoveManually]);


  //#region lógica

  const getTask = async () => {
    try {
      const taskData = await getTaskByTrelloId(id || "");
      if (taskData.success) {
        const normalized = normalizeTaskFromApi(taskData.data, id);
        if (!normalized) {
          notify("Tarefa não encontrada.", { type: "error" });
          return;
        }

        setPartnerCustomer(normalized.partnersCustomers ?? []);
        setTask(normalized);

        if (normalized.membersName != null && normalized.membersName.length > 0) {
          const members = normalized.membersName.map(
            (memberName: string, index: number) => ({
              value: normalized.memberIds[index],
              label: memberName,
            })
          );
          setSelectedMembers(members);
        }

        const tools = (normalized.toolsName ?? []).map((toolName, index) => ({
          value: normalized.toolsIds[index],
          label: toolName,
        }));
        setSelectedTools(tools);
      } else {
        notify(taskData.msg, { type: "error" });
      }
    } catch (error) {
      notify(error, { type: "error" });
    }
  };

  useEffect(() => {
    if (userRole === "Dev" || userRole === "Tester") {
      const fetchDevTaskInfo = async () => {
        const data = await getTaskDevInfo(id);
        if (data.success) {
          if (data.data != null) {
            setTaskHistory(data.data);
          }
          setIsUserAssigned(data.assignedUser);
        }
      };

      fetchDevTaskInfo();
    }
  }, [userRole]);

  useEffect(() => {
    const filteredActivities = () => {
      if (activitiesFilter === "-1") {
        setActivities(comments);
      } else if (activitiesFilter === "0") {
        setActivities(
          comments.filter(
            (c) =>
              c.actionType === "Comment" ||
              c.actionType === "CommentUploadHomolog"
          )
        );
      } else if (activitiesFilter === "1") {
        setActivities(
          comments.filter(
            (c) => c.actionType === "JoinTask" || c.actionType === "LeaveTask"
          )
        );
      } else if (activitiesFilter === "2") {
        setActivities(comments.filter((c) => c.actionType === "MoveTask"));
      }
    };
    filteredActivities();
  }, [comments, activitiesFilter]);

  useEffect(() => {
    if (
      task != null &&
      task.membersName != null &&
      task.membersName.length > 0
    ) {
      document.title = task.title;
      setSelectedMembers(
        task.membersName.map((memberName, index) => ({
          value: task.membersName[index],
          label: memberName,
        }))
      );
    }

    if (task.evidencies != null && task.evidencies.length > 0) {
      setEvidenciesIds(task.allResourcesEvidencies);
    }
  }, [task]);


  useEffect(() => {
    const getUserRole = async () => {
      const data = await getCurrentUserRole();
      if (data.success) {
        setUserRole(data.data);
      }
    };

    const getStatus = async () => {
      const data = await getAllStatus();
      if (data.data) {
        setStatusList(data.data);
      }
    };

    getStatus();
    getUserRole();
    fetchCurrentMember();

    if (id !== "new") {
      getTask();
      fetchComments();
    }
  }, [id]);

  useEffect(() => {
    var currentStatus = statusList.find((s) => s.id === task.listId);
    var nexttStateName = currentStatus?.nextStateName;
    var reprvStateName = currentStatus?.reproveStateName;
    setReproveStateName(reprvStateName ? reprvStateName : "");
    setNextStateName(nexttStateName ? nexttStateName : "");
  }, [task, statusList]);


  const fetchCurrentMember = async () => {
    try {
      let data = await getCurrentMember();
      if (data.success) {
        setCurrentMember(data.data);
        if (typeof (data?.data?.canScreening) != "undefined" && data.data.canScreening) {
          setUserCanScreening(true);
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  const canUserMoveTask = () => {
    return (
      currentMember?.memberType === "2" ||
      currentMember?.type === 2 ||
      userRole == "Geren" ||
      currentMember?.canMoveTasksManually
    );
  };

  const canUserEditDeadline = () => {
    return (
      currentMember?.memberType === "2" ||
      currentMember?.type === 2 ||
      userRole == "Geren" ||
      currentMember?.canEditDeadline
    );
  };

  const handleOpenEditDeadline = () => {
    const hasDeadline = task.finishDate && task.finishDate !== "0001-01-01T00:00:00.000Z";
    setNewDeadline(hasDeadline ? new Date(task.finishDate).toISOString().split("T")[0] : "");
    setDeadlineJustification("");
    setModalEditDeadline(true);
  };

  const handleConfirmDeadlineChange = async () => {
    if (!deadlineJustification.trim()) {
      notify("Informe a justificativa para alteração do prazo.", { type: "error" });
      return;
    }
    if (!newDeadline) {
      notify("Informe o novo prazo de entrega.", { type: "error" });
      return;
    }

    try {
      const data = await updateDeadline(id || "", {
        newFinishDate: newDeadline,
        justification: deadlineJustification.trim(),
      });

      if (data.success) {
        notify("Prazo alterado com sucesso!", { type: "success" });
        setModalEditDeadline(false);
        await getTask();
        await fetchComments();
      } else {
        notify(data.msg || "Erro ao alterar prazo", { type: "error" });
      }
    } catch (error) {
      notify("Erro ao alterar prazo", { type: "error" });
    }
  };

  const fetchComments = async () => {
    try {
      const data = await getTaskActions(id || "");
      if (data.success) {
        // console.log("Data", data)
        setComments(data.data);
        setActivities(data.data);
      }
    } catch (error) {
      notify(error, { type: "error" });
    }
  };



  const handleEditItem = () => {
    navigate(`/task/edit/${id}`);
  };

  const toggleUploadDbModal = () => {
    setModalUploadDb(!modalUploadDb);
  };
  const handleUploadHomologacao = () => {
    // Copia a lista de outros parceiros e outros clientes
    var copy = JSON.parse(JSON.stringify(task));
    let partnerCustomerUpload: IPartnerCustomerRelationship[] =
      copy.partnersCustomers;
    let pc: IPartnerCustomerRelationship = {
      partnerEmail: copy.partnerEmail,
      customerEmail: copy.customerEmail,
    };
    partnerCustomerUpload.push(pc);
    setEmailsUploadDb(partnerCustomerUpload);
    toggleUploadDbModal();
  };

  const handleMoveTaskNextStatus = async () => {
    try {
      var data = await moveTaskToNextStatus(id ? id : "");
      if (data.success) {
        notify("Tarefa movida com sucesso para o próximo status", {
          type: "success",
        });
        await getTask();
        await fetchComments();
      } else {
        notify(data.msg, { type: "error" });
      }
    } catch (error) { }
        console.log("");
  };

  const handleMoveTaskNextStatusAndJoin = async () => {
    try {
      var data = await moveTaskToNextStatus(id ? id : "");
      if (data.success) {
        const joinData = await joinTheTask(id || "");
        if (!joinData.success) {
          notify(joinData.msg, { type: "error" });
        }
        notify("Tarefa movida com sucesso para o próximo status", {
          type: "success",
        });
        setTimeout(() => {
          window.location.reload();
        }, 300);
      } else {
        notify(data.msg, { type: "error" });
      }
    } catch (error) {
      notify(error, { type: "error" });
    }
  };


  const handleAproveTask = async () => {
    const btn = document.getElementById("btn-aprove-task") as any;
    btn.disabled = true;
    btn.innerHTML = "...";

    try {

      if (task.isCustomization != null && task.isCustomization) {
        const data = await aprovePartnerCustomization(id, customizationConditions);
        if (data.success) {
          notify("Email enviado para o parceiro e tarefa movida para Aguardando Resposta", {
            type: "success",
          });
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        } else {
          notify(data.msg, { type: "error" });
        }
      } else {

        if (newPriority == "" || newPriority == "-1") {
          notify("SELECIONE A PRIORIDADE!", { type: "info" });
        } else {
          const data = await aprovePartnerTask(id, newPriority);
          if (data.success) {
            notify("A tarefa foi aprovada e movida para o backlog", {
              type: "success",
            });
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          } else {
            notify(data.msg, { type: "error" });
          }
        }
      }

    } catch (error) {
      notify(error, { type: "error" });
    } finally {
      btn.disabled = false;
      btn.innerHTML = "Confirmar";
    }
  };

  const handleNewComment = async () => {
    const btn = document.getElementById("btn-comment-new") as any;

    btn.disabled = true;
    btn.innerHTML = "...";

    try {
      if (newComment == "" || newComment.length == 0) {
        notify("O comentário não pode ser vazio!", { type: "info" });
      } else {
        const data = await addNewComment(id || "", newComment, viewerCode);
        setComments(data.data);
        setModal(false);
        setNewComment("");
      }
    } catch (error) {
      notify(error, { type: "error" });
    } finally {
      btn.disabled = false;
      btn.innerHTML = "Confirmar";
    }
  };

  const handleNewAvoidTask = async () => {
    const btn = document.getElementById("btn-avoid-task") as any;

    btn.disabled = true;
    btn.innerHTML = "...";

    try {
      if (newComment == "" || newComment.length == 0) {
        notify("O campo não pode estar vazio!", { type: "info" });
      } else {
        const data = await avoidTask(id || "", newComment);
        if (data.success) {
          await getTask()
          setComments(data.data);
          setModalAvoidTask(false);
          setNewComment("");
          notify("Sucesso! A tarefa foi reprovada", {
            type: "success",
          });
          setComments(data.data);
          setActivities(data.data);
        } else {
          notify(data.msg != "" ? data.msg : "Ocorreu um erro!", {
            type: "error",
          });
        }
      }
    } catch (error) {
      notify(error, { type: "error" });
    } finally {
      btn.disabled = false;
      btn.innerHTML = "Confirmar";
    }
  };

  const handleStartTaskDevelopment = async () => {
    const btn = document.getElementById("btn-init-dev") as any;

    btn.disabled = true;
    btn.innerHTML = "...";

    try {
      const data =
        taskHistory != null && taskHistory.includes("Iniciada")
          ? await stopTaskDevelopment(id)
          : await startTaskDevelopment(id);
      if (data.success) {
        if (data.data != null) setTaskHistory(data.data);
        notify("Sucesso!", { type: "success" });
      } else {
        notify(data.msg, { type: "error" });
      }
    } catch (error) {
      notify(error, { type: "error" });
    } finally {
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    }
  };

  const handleJoinTheTask = async () => {
    try {
      const data = await joinTheTask(id || "");
      if (data.success) {
        if (data.data) {
          notify("Sucesso!");

        }
      } else {
        notify(data.msg, { type: "error" });
      }
    } catch (error) {
      notify(error, { type: "error" });
    }
  };

  const handleLeaveTheTask = async () => {
    try {
      const data = await leaveTheTask(id || "");
      if (data.success) {
        if (data.data) {
          notify("Sucesso!");
          setTimeout(() => {
            window.location.reload();
          }, 300);
        }
      }
    } catch (error) {
      notify(error, { type: "error" });
    }
  };

  const handleAvoidTask = () => {
    setModalAvoidTask(true);
  };

  const getTaskPriority = () => {
    switch (task.priority) {
      case "veryHigh":
        return "Altíssima";
      case "hight":
        return "Alta";
      case "medium":
        return "Média";
      case "low":
        return "Baixa";
      case "veryLow":
        return "Muito Baixa";
      default:
        return "Em análise";
    }
  };

  function handleFormatData(dateString: any) {
    const date = new Date(dateString);

    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();

    const formated = `${day}/${month}/${year}`;

    return formated;
  }

  const handleMoveTask = async (name: string) => {
    try {
      const data = await moveTaskToList(name, id || "");
      if (data.success) {
        notify("Movido com sucesso", { type: "success" });
        await getTask()
        await fetchComments()
      } else {
        notify(data.msg, { type: "error" });
      }
    } catch (error) {
      notify(error, { type: "error" });
    }
  };

  const handleEditComment = async () => {
    const btn = document.getElementById("btn-edit-comment") as any;

    btn.disabled = true;
    btn.innerHTML = "...";

    try {
      if (newComment == "" || newComment.length == 0) {
        notify("O comentário não pode ser vazio!", { type: "info" });
      } else {
        const data = await editComment(id || "", commentToEdit, newComment);

        setComments(data);
        setModalEditComment(false);
        setNewComment("");
        notify("Sucesso!", { type: "success" });
        // setTimeout(() => {
        //   window.location.reload();
        // }, 300);
      }
    } catch (error) {
      notify(error, { type: "error" });
    } finally {
      btn.disabled = false;
      btn.innerHTML = "Confirmar";
    }
  };

  const handleDeleteComment = async (commentId: string) => {
    // const btn = document.getElementById("btn-delete-comment") as any;

    // btn.disabled = true;
    // btn.innerHTML = "...";

    try {
      const data = await deleteComment(id || "", commentId);
      if (data.success) {
        setComments(data.data);
        setModalDeleteComment(false);
        setNewComment("");
        notify("Sucesso!", { type: "success" });
      }

    } catch (error) {
      notify(error, { type: "error" });
    } finally {
      // btn.disabled = false;
      // btn.innerHTML = "Excluir";
    }
  };

  function padZero(number: number) {
    return number.toString().padStart(2, "0");
  }

  function objectIdToDate(objectId: any) {
    const timestamp = parseInt(objectId.substring(0, 8), 16) * 1000;

    const date = new Date(timestamp);

    const formattedDate = `${padZero(date.getDate())}/${padZero(
      date.getMonth() + 1
    )}/${date.getFullYear()} ${padZero(date.getHours())}:${padZero(
      date.getMinutes()
    )}:${padZero(date.getSeconds())}`;

    return formattedDate;
  }

  const handleFormatFlow = () => {
    const partes = task.flow.split("->");

    const stringFormatada = partes.map((parte, index) => (
      <React.Fragment key={index}>
        {" "}
        {parte.trim()}{" "}
        {index < partes.length - 1 && (
          <>
            <FaLongArrowAltRight color="red" />
          </>
        )}
      </React.Fragment>
    ));

    return stringFormatada;
  };

  const handleClickResource = async (link: string, id: string) => {
    try {
      const blob = await getTaskEvidency(id);
      if (blob) {
        const url = URL.createObjectURL(blob);
        
        // If it's an image or video, open in fullscreen
        if (blob.type.startsWith('image/') || blob.type.startsWith('video/')) {
          setEvidenciesImages([url]);
          setIsFullscreen(true);
          setFullScreenIndex(0);
        } else {
          // For other files, trigger download
          const a = document.createElement('a');
          a.href = url;
          a.download = `evidencia_${id}`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
        }
      } else {
        notify("Erro ao carregar a evidência", { type: "error" });
      }
    } catch (error) {
      notify("Erro ao carregar a evidência", { type: "error" });
      console.error("Erro ao carregar evidência:", error);
    }
  };


  const openEvidency = async (id: string) => {
    const blob = await getTaskEvidency(id);
    if (!blob) return;

    const fileType = blob.type;
    const url = URL.createObjectURL(blob);

    // Se for imagem ou vídeo, exibe no media viewer
    if (fileType.startsWith("image/") || fileType.startsWith("video/")) {
      window.open(url, "_blank");
      return;
    }

    // Para outros arquivos, faz o download
    const a = document.createElement("a");
    a.href = url;
    a.download = `evidencia_${id}`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };


  //#endregion
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const toggleFullscreen = () => {
    setIsFullscreen(!isFullscreen);
  };

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const selectedFiles = e.target.files;
    setFiles(selectedFiles || null);
  };

  const handleUpload = async () => {
    if (!files || files.length == 0) return

    const btn = document.getElementById("evidencies-button") as any;
    btn.disabled = true;
    btn.innerHTML = "...";

    if (files) {

      try {
        const formData = new FormData();

        for (let i = 0; i < files.length; i++) {
          formData.append(`file${i}`, files[i]);
        }

        //TESTE
        // `https://localhost:44485/Tasks/upload-task-resources/${id}`,
        const response = await axios.post(
          `https://devtracker.vendaerp.com.br/Tasks/upload-task-resources/${id}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            responseType: "blob",
          }
        );

        if (response.status === 200) {
          notify("Arquivo adicionado com sucesso!", { type: "success" });
          await getTask()

        } else {
          notify("O upload falhou!", {
            type: "alert",
          });
        }
      } catch (error) {
        notify("O arquivo ultrapassa o limite de tamanho!", { type: "error" });
      } finally {
        btn.disabled = false;
        btn.innerHTML = "Adicionar";
      }
    }
  };

  const handleOpenModalNewComment = () => {
    setNewComment(""); // <- limpa antes de abrir qualquer modal
  
    if (userRole === "Viewer") {
      setViewerCommentModal(true);
    } else {
      setModal(true);
    }
  };
  

  const handleGetCommentCode = async () => {
    const btn = document.getElementById("btn-code-new") as any;
    btn.disabled = true;
    btn.innerHTML = "...";
    try {
      const data = await getCode(viewerEmail, id || "");
      if (data.success && data.data != false) {
        notify("O código foi enviado para o email informado!", { type: "success" });
        setViewerCommentModal(false);
        setViewerEmail("");
        setModal(true);
      } else {
        notify(`Ops: ${data.msg}`, { type: "error" });
        setViewerEmail("");
      }
    } catch (error) {
      notify(`Ops: ${error}`, { type: "error" });
    } finally {
      btn.disabled = false;
      btn.innerHTML = "Gerar código";
    }
  };

  return (
    <div className="page-container task-view-container">
      <div
        className="d-flex align-center justify-content-between"
      >
        <div className="task-header">
          <Row>
            <Col md={userRole == "Viewer" ? 12 : 8}>
              <div className="task-title-section">
                {/* Status Badge - Positioned at top left */}
                <div className="task-status-badge-container">
                  {statusList.map((item, index) => {
                    if (item.id == task.listId) {
                      return (
                        <div key={index} className={`status-badge status-${item.name.toLowerCase().replace(/\s+/g, '-')}`}>
                          📍 {item.name}
                        </div>
                      );
                    }
                    return null;
                  })}
                </div>
                
                <h2>
                  {task.EhParceiroPrioritario ? (
                    <FaStar color="#f5c518" size={18} style={{ marginRight: "8px", marginBottom: "4px" }} />
                  ) : null}
                  {task.title}
                </h2>
                
                {/* Optional: Full breadcrumb for context */}
                <div className="task-breadcrumb">
                  {statusList.map((item, index) => {
                    return (
                      <div
                        key={index}
                        className={`task-breadcrumb-item ${item.id == task.listId ? 'active' : ''}`}
                      >
                        <span>{item.name}</span>
                        {statusList.length - 1 !== index && <span>›</span>}
                      </div>
                    );
                  })}
                </div>
              </div>
            </Col>
            {userRole != "Viewer" && (
              <Col
                md={4}
                lg={4}
                className="task-actions-section"
              >
                <>
                  {id != "new" && userRole != "Viewer" && task.listName == "Triagem" && task.isCustomization != null && task.isCustomization ?
                    <React.Fragment>
                      <UncontrolledDropdown className="task-action-dropdown">
                        <DropdownToggle
                          caret
                          className="task-action-dropdown"
                        >
                          Mais Ações
                        </DropdownToggle>
                        <DropdownMenu className="custom-dropdown-menu">
                          <DropdownItem
                            className="custom-dropdown-item"
                            onClick={() => setModalAproveCustomization(true)}
                          >
                            Aprovar Customização
                          </DropdownItem>
                          <DropdownItem
                            className="custom-dropdown-item"
                            onClick={() => handleAvoidTask()}
                          >
                            Reprovar Customização
                          </DropdownItem>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </React.Fragment>
                    : <React.Fragment>
                      {id != "new" && userRole != "Viewer" && (
                        <UncontrolledDropdown className="task-action-dropdown">
                          <DropdownToggle
                            caret
                            className="task-action-dropdown"
                          >
                            Mais Ações
                          </DropdownToggle>
                          {task.fromApi != null &&
                            task.fromApi &&
                            task.isAproved != null &&
                            !task.isAproved ? (
                            <DropdownMenu className="custom-dropdown-menu">
                              {userCanScreening && (
                                <>
                                  <DropdownItem
                                    className="custom-dropdown-item"
                                    onClick={() => setModalAproveTask(true)}
                                  >
                                    Aprovar Tarefa
                                  </DropdownItem>
                                  <DropdownItem
                                    className="custom-dropdown-item"
                                    onClick={() => setModalAvoidTask(true)}
                                  >
                                    Reprovar Tarefa
                                  </DropdownItem>
                                </>
                              )}
                            </DropdownMenu>
                          ) : (
                            <DropdownMenu className="custom-dropdown-menu">
                              <DropdownItem
                                className="custom-dropdown-item"
                                onClick={() => setModalMoveTaskNextStatus(!modal)}
                              >
                                Mover para o próximo status{" "}
                                {nextStateName ? `(${nextStateName})` : ""}
                              </DropdownItem>
                              <DropdownItem
                                className="custom-dropdown-item"
                                onClick={() => handleAvoidTask()}
                              >
                                Mover para o status predecessor{" "}
                                {reproveStateName ? `(${reproveStateName})` : ""}
                              </DropdownItem>

                              {
                                task.listId == VendaERPDefaultStatus.FatorExterno &&
                                <DropdownItem
                                  className="custom-dropdown-item"
                                  onClick={() => setModalExternalFactor(!modalExternalFactor)}
                                >
                                  Criar Tarefa de Análise
                                </DropdownItem>
                              }

                              <DropdownItem
                                className="custom-dropdown-item"
                                onClick={() => handleEditItem()}
                              >
                                Editar
                              </DropdownItem>

                              <DropdownItem
                                className="custom-dropdown-item"
                                onClick={() => handleUploadHomologacao()}
                              >
                                Clonar base(s)
                              </DropdownItem>
                              {(userRole === "Dev" || userRole === "Tester") &&
                                !isUserAssigned && (
                                  <DropdownItem
                                    className="custom-dropdown-item"
                                    onClick={() => handleJoinTheTask()}
                                  >
                                    Ingressar
                                  </DropdownItem>
                                )}
                              {(userRole === "Dev" || userRole === "Tester") &&
                                isUserAssigned && (
                                  <DropdownItem
                                    className="custom-dropdown-item"
                                    onClick={() => handleLeaveTheTask()}
                                  >
                                    Sair da Tarefa
                                  </DropdownItem>
                                )}
                              {/* <DropdownItem
                            className="custom-dropdown-item"
                            onClick={()=>handleAvoidTask()}>
                                                Recusar Tarefa
                                              </DropdownItem> */}

                              {canUserMoveTask() && (
                                <span>
                                  <DropdownItem
                                    className="custom-dropdown-item"
                                    header
                                  >
                                    <b style={{ color: "#2528ff" }}>
                                      Mover Tarefa Para:
                                    </b>
                                  </DropdownItem>
                                  {statusList != null &&
                                    statusList.map((e, i) => {
                                      return (
                                        <DropdownItem
                                          className="custom-dropdown-item"
                                          key={i}
                                          onClick={() =>
                                            setStatusNameToMoveManually(e.name)
                                          }
                                        >
                                          {e.name}
                                        </DropdownItem>
                                      );
                                    })}
                                </span>
                              )}
                            </DropdownMenu>
                          )}
                        </UncontrolledDropdown>
                      )}
                    </React.Fragment>
                  }
                  {userRole === "Dev" && isUserAssigned && (
                    <Button
                      className="task-primary-button"
                      id="btn-init-dev"
                      onClick={() => handleStartTaskDevelopment()}
                    >
                      {taskHistory != null &&
                        taskHistory.includes("Iniciada") ? (
                        <span style={{ fontSize: 14 }}>
                          <FaCirclePause
                            color="#fff"
                            style={{ marginBottom: "2px", marginRight: "2px" }}
                          />
                          Desenvolvimento
                        </span>
                      ) : (
                        <span style={{ fontSize: 14 }}>
                          <FaCirclePlay
                            color="#fff"
                            style={{ marginBottom: "2px", marginRight: "2px" }}
                          />
                          Desenvolvimento
                        </span>
                      )}
                    </Button>
                  )}
                </>
              </Col>
            )}
          </Row>
        </div>
      </div>
      <div className="mt-1 mb-5">
        <Form>
          <div className="task-responsible-section">
            <div className="task-responsible-content">
              <span className="task-responsible-label">Responsáveis:</span>
              <div className="task-responsible-names">
                {selectedMembers != null &&
                  selectedMembers.map((member, index) => {
                    return (
                      <span className="task-responsible-name" key={index}>
                        {member.label}
                      </span>
                    );
                  })}
              </div>
              {selectedTools != null && selectedTools.length > 0 && (
                <>
                  <span>|</span>
                  <span className="task-responsible-label">Software:</span>
                  <div className="task-responsible-names">
                    {selectedTools.map((tool, index) => {
                      return (
                        <span className="task-responsible-name" key={index}>
                          {tool.label}
                        </span>
                      );
                    })}
                  </div>
                </>
              )}
            </div>
          </div>
          
          <div className="task-divider"></div>

          <TaskGeneralInfo
            task={task}
            canEditDeadline={canUserEditDeadline()}
            onEditDeadline={handleOpenEditDeadline}
          ></TaskGeneralInfo>
          <TaskPartnerInfo task={task} userRole={userRole} partnerCustomer={partnerCustomer}></TaskPartnerInfo>
          <TaskProblemSummary task={task} userRole={userRole} ></TaskProblemSummary>
        
          <TaskEvidences
            task={task}
            onFileChange={handleFileChange}
            onUpload={handleUpload}
            onEvidenceClick={handleClickResource}
          />
        </Form>
        <TaskHistory
          activities={activities}
          userRole={userRole}
          onEditComment={(text, commentId) => {
            setCommentToEdit(commentId); 
            setNewComment(text); 
            setModalEditComment(true);
          }}
          onDeleteComment={(commentId) => {
            setCommentToDelete(commentId);
            setModalDeleteComment(true);
          }}
          onNewComment={handleOpenModalNewComment}
          activitiesFilter={activitiesFilter}
          setActivitiesFilter={setActivitiesFilter}
        ></TaskHistory>
      </div>

      <EditDeadlineModal
        isOpen={modalEditDeadline}
        toggle={() => setModalEditDeadline(false)}
        currentDeadline={
          task.finishDate && task.finishDate !== "0001-01-01T00:00:00.000Z"
            ? new Date(task.finishDate).toLocaleDateString("pt-BR")
            : null
        }
        newDeadline={newDeadline}
        setNewDeadline={setNewDeadline}
        justification={deadlineJustification}
        setJustification={setDeadlineJustification}
        onConfirm={handleConfirmDeadlineChange}
      />

      <NewCommentModal
        isOpen={modal}
        toggle={() => setModal(false)}
        comment={newComment}
        setComment={setNewComment}
        userRole={userRole}
        viewerCode={viewerCode}
        setViewerCode={setViewerCode}
        onConfirm={() => handleNewComment()}
      >
      </NewCommentModal>

      <ViewerCommentCodeModal
        isOpen={viewerCommentModal}
        toggle={() => setViewerCommentModal(false)}
        email={viewerEmail}
        setEmail={setViewerEmail}
        onGenerate={() => handleGetCommentCode()}
      >
      </ViewerCommentCodeModal>

      <AvoidTaskModal
        isOpen={modalAvoidTask}
        toggle={() => setModalAvoidTask(!modalAvoidTask)}
        reproveStateName={reproveStateName}
        comment={newComment}
        setComment={setNewComment}
        onConfirm={handleNewAvoidTask}
      ></AvoidTaskModal>

      <EditCommentModal
        isOpen={modalEditComment}
        toggle={() => setModalEditComment(false)}
        comment={newComment}
        setComment={setNewComment}
        onConfirm={() => handleEditComment()}
      ></EditCommentModal>

      <AproveTaskModal
        isOpen={modalAproveTask}
        toggle={() => setModalAproveTask(!modalAproveTask)}
        priority={task.priority}
        setPriority={setNewPriority}
        onConfirm={() => handleAproveTask()}
      ></AproveTaskModal>

      <AproveCustomizationModal
        isOpen={modalAproveCustomization}
        toggle={() => setModalAproveCustomization(false)}
        onConfirm={() => handleAproveTask()}
        conditions={customizationConditions}
        setConditions={setCustomizationConditions}
      ></AproveCustomizationModal>

      <DeleteCommentModal
        isOpen={modalDeleteComment}
        toggle={() => setModalDeleteComment(false)}
        onConfirm={() => handleDeleteComment(commentToDelete)}>
      </DeleteCommentModal>

      <MoveTaskModal
        isOpen={modalMoveTaskNextStatus}
        toggleModal={() => setModalMoveTaskNextStatus(!modalMoveTaskNextStatus)}
        moveTask={handleMoveTaskNextStatus}
        moveTaskAndJoin={
          (userRole === "Dev" || userRole === "Tester") && !isUserAssigned
            ? handleMoveTaskNextStatusAndJoin
            : undefined
        }
      ></MoveTaskModal>

      <MoveTaskModal
        isOpen={modalMoveTask}
        toggleModal={() => setModalMoveTask(!modalMoveTask)}
        moveTask={() => handleMoveTask(statusNameToMoveManually)}
      ></MoveTaskModal>

      <UploadDbModal
        taskId={id ? id : ""}
        isOpen={modalUploadDb}
        toggleUploadDbModal={toggleUploadDbModal}
        partnerCustomer={emailsUploadDb}
      ></UploadDbModal>

      <ExternalFactorModal
        isOpen={modalExternalFactor}
        toggleModal={() => { setModalExternalFactor(!modalExternalFactor) }}
        taskId={id ? id : ""}
      />
      {isFullscreen && (
        <MediaViewer
          items={evidenciesImages}
          action={() => setIsFullscreen(false)}
          index={fullScreenIndex}
        />
      )}
    </div>
  );
}

export default TaskView;
